import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Cancellations and Refunds | ShipSticks',
  description:
    'Learn about our cancellation and refund policies. ' +
    'We offer flexible options to fit your changing travel plans.',
  alternates: {
    canonical: 'https://www.shipsticks.com/cancellations-and-refunds',
  },
}

export default metadata
